var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.75c-.75 0-1.3-.03-1.77-.1-3.32-.36-3.98-2.35-3.98-5.65V9c0-3.3.66-5.29 4.01-5.66.44-.06.99-.09 1.74-.09h9c.75 0 1.3.03 1.77.1 3.32.36 3.98 2.35 3.98 5.65v6c0 3.3-.66 5.29-4.01 5.66-.44.06-.99.09-1.74.09h-9zM5.95 4.83c-2.03.23-2.7.86-2.7 4.17v6c0 3.31.67 3.94 2.67 4.17.42.06.9.08 1.58.08h9c.68 0 1.16-.03 1.55-.08 2.03-.22 2.7-.86 2.7-4.17V9c0-3.31-.67-3.94-2.67-4.17-.42-.06-.9-.08-1.58-.08h-9c-.68 0-1.16.03-1.55.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H17c.41 0 .75.34.75.75s-.34.75-.75.75h-3.5zM9.1 10c0-.55.44-1 1-1h.01c.55 0 1 .45 1 1a1.005 1.005 0 0 1-2.01 0zM6.1 10c0-.55.44-1 1-1 .55 0 1 .45 1 1s-.44 1-1 1c-.55 0-1-.45-1-1zM7.02 16.25c-.41 0-.76-.34-.76-.75s.33-.75.74-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75H7.02z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineKeyboard);
export default __webpack_public_path__ + "static/media/vuesax-outline-keyboard.9cc70f46ffbafa87e1f72f7ac00a5245.svg";
export { ForwardRef as ReactComponent };